<script>
	export default {
		onLaunch: function() {
			console.log('App Launch')
		},
		onShow: function() {
			console.log('App Show')
		},
		onHide: function() {
			console.log('App Hide')
		}
	}
</script>

<style lang="scss">
	/*每个页面公共css */
	@import "uview-ui/index.scss";
	.flex-cb {
	  display: flex;
	  justify-content: space-between;
	  align-items: center;
	}
	
	.container {
	  height: 100%;
	  width: 100%;
	  max-width: 800rpx;
	  overflow-y: auto;
	}
	
	.doumee-container .ivu-tabs-nav {
	  width: 100%;
	}
	
	.doumee-container .ivu-tabs-nav .ivu-tabs-tab {
	  width: calc(100% / 3);
	}
	
	.doumee-container .ivu-tabs-nav .ivu-tabs-tab {
	  margin-right: 0;
	  text-align: center;
	}
	
	.cell {
	  background-color: #fff;
	  display: flex;
	  justify-content: space-between;
	  align-items: center;
	  min-height: 100rpx;
	  padding: 24rpx 30rpx;
	  box-sizing: border-box;
	  border-bottom: 1rpx solid #eee;
	  font-size: 15rpx;
	  position: relative;
	}
	
	.cell .title {
		flex-shrink: 0;
		color: #222;
		line-height: 20rpx;
		height: 20rpx;
		width: 28%;
		margin-right: 5%;
	}
	
	.cell .content {
		flex: 1;
		font-size: 28rpx;
		font-weight: 400;
		color: #999999;
		display: flex;
		align-items: center;
		justify-content: flex-end;
	}
	
	.cell .content .input {
		width: 100%;
		height: 100%;
		font-size: 28rpx;
		font-weight: 400;
		color: #333333;
		text-align: right;
	}
	
	.cell.is-link::after {
		content: '';
		display: block;
		width: 8rpx;
		height: 8rpx;
		transform: rotate(-45deg);
		border-right: 1rpx solid #999999;
		border-bottom: 1rpx solid #999999;
		margin-left: 5rpx;
	}
	
	.card {
	  background-color: #fff;
	  padding: 16rpx;
	  position: relative;
	}
	
	.card::after {
	  content: '';
	  display: block;
	  position: absolute;
	  width: calc(100% - 32rpx);
	  height: 0;
	  bottom: 0;
	  left: 16rpx;
	  border-bottom: 1rpx solid #f7f7f7;
	}
	
	.card .title {
	  color: #777777;
	  margin-bottom: 12rpx;
	}
	
	.card .content {
	  color: #222;
	}
</style>
